import React from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      text: "This is one of the most well-organized system design courses I've taken. The instructor focuses on the 'why' behind architectural decisions, not just the 'what.' The real-world case studies like designing YouTube, WhatsApp, and URL Shorteners are broken down thoughtfully with clear diagrams and trade-offs. Even with prior experience in backend and cloud systems, I found the explanations refreshing.",
      author: "Milan",
      rating: 5,
      avatar: "MI",
      color: "#c0ff00",
      outcome: "Cleared Amazon SDE-2 round"
    },
    {
      text: "The biggest plus for me was the clear, consistent framework used across all designs - it helps you know exactly how much to talk about and how to structure your answer in a 40-minute interview. The videos are sized perfectly to show how you'd use existing tools and present a solid design solution. For system design interviews, coming up with a clear, well-structured design is the main priority.",
      author: "Reshma",
      rating: 5,
      avatar: "RE",
      color: "#60a5fa",
      outcome: "Got Google L4 offer"
    },
    {
      text: "A key strength of the course is that it doesn't just teach how things are built, but also why certain approaches are chosen - and just as importantly, why they are not. This focus on trade-offs cultivates a structured way of thinking. Before this course, I was unfamiliar with many techniques in modern distributed systems. Now I feel equipped with a mental toolkit to approach new scenarios methodically.",
      author: "Deepkumar",
      rating: 5,
      avatar: "DK",
      color: "#a78bfa"
    },
    {
      text: "The instructors didn't just teach how systems work - they taught how to think like an engineer at scale.",
      author: "Vamsi",
      rating: 5,
      avatar: "VA",
      color: "#f472b6"
    },
    {
      text: "I finally understood how to approach problems like designing Twitter, URL shortener, and rate limiter. The real-life scenarios and trade-offs discussed made a big difference for me. It feels like I'm actually ready to face system design rounds now. Highly recommended if you're preparing for interviews at top tech companies.",
      author: "Rakesh",
      rating: 4,
      avatar: "RA",
      color: "#34d399",
      outcome: "Cleared Microsoft Senior SDE round"
    },
    {
      text: "I can truly say this is EXACTLY what I was looking for. I spent countless hours on YouTube trying to find resources but nothing was satisfactory or organized. This is a perfect zero-to-one course that teaches design thinking in a way you can remember through standardizations like templates. Amazing job on covering YouTube and WhatsApp and especially the quizzes.",
      author: "Ish",
      rating: 5,
      avatar: "IS",
      color: "#fb923c"
    },
    {
      text: "The System Design Masterclass changed the way I think about system design. Before, I found the subject boring and confusing, but this course made it interesting and useful. The instructors effectively deconstruct complex concepts and emphasize clear, practical methodologies. The curriculum includes designing real-world systems like Instagram and YouTube using a systematic template.",
      author: "Jit",
      rating: 5,
      avatar: "JI",
      color: "#c0ff00"
    },
    {
      text: "One of the best and most engaging System Design courses I've learned from. The best part is that they follow the same template to approach all HLD problems - this makes every question feel connected with new and specific things added. Waiting for a similar course on LLD too.",
      author: "Devendra",
      rating: 5,
      avatar: "DE",
      color: "#60a5fa"
    },
    {
      text: "This is an amazing course. I am in middle management in big tech and keep my skills sharp by taking design courses periodically. This is a very good course. I would recommend students go through all appendices before diving into individual cases - they have really good information.",
      author: "Naveed",
      rating: 5,
      avatar: "NA",
      color: "#a78bfa"
    },
    {
      text: "SD used to be a boring subject and there are hell lot of courses available - all of them just show PPTs and that's how it gets boring. New Gen Engineers made this subject so awesome that I could understand and clear the interviews. Thank you guys.",
      author: "Deepak",
      rating: 5,
      avatar: "DP",
      color: "#f472b6",
      outcome: "Cracked 3 FAANG design rounds"
    },
    {
      text: "Course is detailed with all these designs. I really liked that all the designs followed 1 simple template - functional requirements, non-functional requirements, capacity estimations, API design, HLD, then deep dive. Nobody has ever taught like this. Really loved the course!",
      author: "Ritu",
      rating: 5,
      avatar: "RI",
      color: "#34d399"
    },
    {
      text: "Pretty awesome. Earlier, I had no idea about system design. Now I not only understand it, but I'm also clear on the concepts. They're doing a great job!",
      author: "Abdul",
      rating: 5,
      avatar: "AB",
      color: "#fb923c"
    },
    {
      text: "The course covers everything from fundamental concepts like load balancing, caching, and database sharding to complex distributed systems such as designing YouTube, Netflix, and WhatsApp. Real-world scenarios simulate actual interview questions. If you're preparing for FAANG-level system design interviews, this course helps you build a systematic approach.",
      author: "Rohan",
      rating: 5,
      avatar: "RO",
      color: "#c0ff00"
    },
    {
      text: "Really enjoyed this course - it breaks system design down in a way that actually makes sense. The YouTube and WhatsApp examples were super helpful, and the framework they teach sticks in your head. Thank you.",
      author: "Ujwal",
      rating: 5,
      avatar: "UJ",
      color: "#60a5fa"
    },
    {
      text: "This course has been extremely helpful in highlighting the importance of stepping back to look at the system as a whole before implementing new or updating existing features. Highly recommend!",
      author: "Mzukisi",
      rating: 5,
      avatar: "MZ",
      color: "#a78bfa"
    },
    {
      text: "The framework is a game changer, thanks guys!",
      author: "David",
      rating: 5,
      avatar: "DA",
      color: "#f472b6"
    },
  ];

  const rowSize = Math.ceil(testimonials.length / 2);
  const row1 = testimonials.slice(0, rowSize);
  const row2 = testimonials.slice(rowSize);
  const duplicatedRow1 = [...row1, ...row1];
  const duplicatedRow2 = [...row2, ...row2];

  const Card = ({ t, index }) => (
    <div key={index} className="testimonial-scroll-card">
      {t.outcome && (
        <div className="testimonial-outcome-badge" style={{ color: t.color, borderColor: `${t.color}55`, background: `${t.color}15` }}>
          🎯 {t.outcome}
        </div>
      )}
      <div className="testimonial-quote-icon">"</div>
      <p className="testimonial-text">{t.text}</p>
      <div className="testimonial-meta">
        <div className="testimonial-avatar" style={{ background: `${t.color}22`, color: t.color, borderColor: `${t.color}44` }}>
          {t.avatar}
        </div>
        <div className="testimonial-author-info">
          <div className="testimonial-author-name">{t.author}</div>
          <div className="testimonial-role">Verified Udemy Student</div>
        </div>
      </div>
      <div className="testimonial-footer">
        <div className="testimonial-stars">{'★'.repeat(t.rating)}{'☆'.repeat(5 - t.rating)}</div>
        <div className="testimonial-course-tag" style={{ color: t.color, borderColor: `${t.color}44`, background: `${t.color}11` }}>
          System Design
        </div>
      </div>
    </div>
  );

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-bg-grid" />

      <div className="section-header">
        <div className="section-badge">Real Students. Real Reviews.</div>
        <h2 className="section-title">
          Trusted by <span className="text-gradient">10,000+ developers</span>
        </h2>
        <p className="section-subtitle">
          Straight from Udemy - unedited reviews from engineers who took the course.
        </p>
        <p className="testimonials-udemy-note">★ Unedited reviews, straight from Udemy</p>
      </div>

      <div className="testimonials-multi-scroll">
        <div className="testimonials-scroll-container">
          <div className="testimonials-scroll-track scroll-left">
            {duplicatedRow1.map((t, i) => <Card key={i} t={t} index={i} />)}
          </div>
        </div>
        <div className="testimonials-scroll-container">
          <div className="testimonials-scroll-track scroll-right">
            {duplicatedRow2.map((t, i) => <Card key={i} t={t} index={i} />)}
          </div>
        </div>
      </div>

      <div className="testimonials-cta-block">
        <p className="testimonials-cta-headline">The results speak for themselves.</p>
        <a href="#courses" className="btn btn-secondary testimonials-cta-btn">
          Explore the Course →
        </a>
      </div>
    </section>
  );
};

export default Testimonials;
